type HeaderPrintListProps = Partial<{
  createdDate: string;
  patientInfo: any;
  formName: string;
  styles: Record<string, any>;
  pageMargins: number[];
}>;

export const AddHeaderPrintListTH = (doc: any, props: HeaderPrintListProps) => {
  return {
    ...doc,
    // logo height 80 + marginHeader 16 = 96 (pageMargins must greater than Header + Header Bottom Margin)
    // margin: [left, top, right, bottom]
    pageMargins: props.pageMargins ? props.pageMargins : [38, 120, 38, 40],
    header: () => {
      return {
        table: {
          widths: ["55%", "45%"],
          body: [
            [
              // Left Side (logo and form name)
              {
                stack: [
                  {
                    image: "logo",
                    width: 300,
                    height: 80,
                    margin: [-21, -21, 0, 0],
                  },
                  {
                    text: props.formName,
                    alignment: `center`,
                    font: `KanitLM`,
                    fontSize: 10,
                    bold: true,
                    margin: [0, -16, 0, 0],
                  },
                ],
                border: [true, true, false, true],
              },
              // Right Side (patient information)
              {
                stack: [
                  {
                    text: ` `,
                    preserveLeadingSpaces: true,
                    font: `KanitLM`,
                    fontSize: 8,
                  },
                  {
                    text: `ชื่อ : ${props.patientInfo?.formatPatient}`,
                    font: `KanitLM`,
                    fontSize: 8,
                    bold: true,
                  },
                  {
                    columns: [
                      {
                        text: `HN : ${props.patientInfo?.hn}`,
                        font: `KanitLM`,
                        fontSize: 8,
                        bold: true,
                      },
                      {
                        text: `EN/AN : ${props.patientInfo?.patientEncounter}`,
                        font: `KanitLM`,
                        fontSize: 8,
                        bold: true,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `วันเกิด : ${props.patientInfo?.birthdate}`,
                        font: `KanitLM`,
                        fontSize: 8,
                        bold: true,
                      },
                      {
                        text: `อายุ : ${props.patientInfo?.ageYear} ปี ${props.patientInfo?.ageMonth} เดือน ${props.patientInfo?.ageDay} วัน`,
                        font: `KanitLM`,
                        fontSize: 8,
                        bold: true,
                      },
                    ],
                  },
                  {
                    text: `เพศ : ${
                      props.patientInfo?.gender
                        ? props.patientInfo.gender === "F"
                          ? "หญิง"
                          : props.patientInfo.gender === "M"
                          ? "ชาย"
                          : props.patientInfo.gender
                        : "ไม่ระบุ"
                    }`,
                    font: `KanitLM`,
                    fontSize: 8,
                    bold: true,
                  },
                  {
                    text: ` `,
                    preserveLeadingSpaces: true,
                    font: `KanitLM`,
                    fontSize: 8,
                  },
                ],
                border: [false, true, true, true],
              },
            ],
          ],
        },
        layout: {
          paddingTop: function (i: any, node: any) {
            return 5;
          },
          paddingBottom: function (i: any, node: any) {
            return 5;
          },
          paddingLeft: function (i: any, node: any) {
            return 5;
          },
          paddingRight: function (i: any, node: any) {
            return 5;
          },
        },
        margin: [16, 16, 16, 0],
      };
    },
    footer: (currentPage: any, pageCount: any) => {
      return {
        columns: [
          {
            text: `วันที่พิมพ์ : ${props.createdDate}`,
            alignment: `left`,
            font: `KanitLM`,
            fontSize: 8,
          },
          {
            text: `หน้า ` + currentPage.toString() + ` จาก ` + pageCount,
            alignment: `right`,
            font: `KanitLM`,
            fontSize: 8,
          },
        ],
        margin: [16, 16, 16, 16],
      };
    },
    images: {
      logo: origin + "/static/images/sapiens/logo_sapiens.png",
    },
    styles: {
      ...(props.styles || {}),
    },
  };
};
